const compactFormatter = new Intl.NumberFormat("en-US", { notation: "compact" });

export const formatCompactNumber = (value: number): string => compactFormatter.format(value);
